module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigation-bar-small"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/",
      "id": "home-control-small"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "page-title"
    }
  }, [_vm._v(_vm._s(this.assessmentName))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/progress/course/' + this.$route.params.id,
      "id": "map-control-small"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mapController"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftLink"
    },
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "rightLink"
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9df06320!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/learn/ProgressHeaderBar.vue
// module id = 602
// module chunks = 2